import type { PartnerConfigInput } from "../../config/schema";
import Logo from "./Logo";
import meta from "./meta.json";

// Default partner config — extracted from current hardcoded values.
// Source-of-truth references (for future audits):
//   appName        ← public/index.html <title>, manifest.json name
//   logo.Component ← ./Logo.tsx (inline SVG component)
//   chat.appId     ← Intercom workspace ID (canonical home: this file)
//   meta.themeColor ← public/manifest.json theme_color, public/index.html theme-color meta
//   meta.canonicalUrl ← public/index.html og:url

const sabo = {
  partnerId: "sabo",
  appName: "Sabo Logistics",

  // Shared with server.js, which serves these as crawler-visible head tags.
  meta,

  logo: {
    alt: "SABO Logistics",
    Component: Logo,
  },

  // The light ground is Porcelain, a neutral grey without the base palette's
  // dot grid: no tint to compete with the landing's warm paper, and deep
  // enough (L* 97.6) that white panels, inputs and the drawer stand off it.
  // The drawer's shadow is fainter and wider than the base one, which on this
  // grey ground left a dark band along the drawer's edge.
  // Everything else is the base palette from src/styles/themes.ts as-is.
  theme: {
    light: {
      surface: "#f8f8f8",
      surfaceTextureDot: "transparent",
      panelShadow: "-4px 0 32px 0 rgba(0, 0, 0, 0.03)",
    },
    dark: {},
  },

  chat: {
    provider: "intercom",
    appId: "g8pf25uo",
  },

  // Partner-level availability. Per-user gating (e.g. allowExtendedTools)
  // remains in place and applies on top of these flags.
  features: {
    shopify: true,
    tools: true,
    support: true,
    delivery: true,
    mailbox: true,
    addressParsing: true,
    inboundParsing: true,
    invoiceParsing: true,
    usdtDeposits: true,
    telegramLink: true,
    smsNumbers: true,
  },

  // Per-user credit_card_allowed still gates credit card on top of this.
  payments: {
    creditCard: true,
    paypal: true,
    overpay: true,
    stripe: true,
  },

  currency: {
    code: "USD",
    symbol: "$",
  },

  signup: {
    mode: "token-required",
  },

  // Anonymous "/" renders the marketing landing (src/containers/Landing).
  publicRoot: "landing",

  // Strict allowlist. Adding a new branch on the BE requires a matching update here.
  branches: {
    sbNames: ["USA", "Germany"],
  },

  // Strict allowlist by Mailbox.country (BE returns full country names like
  // "USA", "Germany"). Multiple mailboxes per country are all shown.
  mailboxes: {
    countries: ["USA", "Germany"],
  },

  // baseUrl omitted — uses default hostname-based routing in src/utils/client.js.
  // homeCardsPrefix kept explicit so the reference config self-documents the URL shape.
  api: {
    homeCardsPrefix: "home_",
  },

  // sentry intentionally omitted — schema default ({ tags: {} }) applies
} satisfies PartnerConfigInput;

export default sabo;
